
import { Suspense, useEffect, lazy } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

// Static imports (components always needed immediately)
import Navbar from "./components/Navigation/Navbar";
import { Error } from "./components/Error/Error";
import SharedLayout from "./components/Navigation/SharedLayout";
import LoadingSpinner from './components/UserInterface/LoadingSpinner';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// Lazy load ALL route components individually (compatible with named exports)
const Home = lazy(() => import("./components/Home/Home").then(module => ({ default: module.Home })));

// Immersive - each component loaded only when needed
const Haze = lazy(() => import("./components/Immersive/Haze/Haze").then(module => ({ default: module.Haze })));
const VirtualPavilion = lazy(() => import("./components/Immersive/VirtualPavilion/VirtualPavilion").then(module => ({ default: module.VirtualPavilion })));
const BreathTaking = lazy(() => import("./components/Immersive/BreathTaking/BreathTaking").then(module => ({ default: module.BreathTaking })));
const Watching = lazy(() => import("./components/Immersive/Watching/Watching").then(module => ({ default: module.Watching })));
const ImmaterialSpaces = lazy(() => import("./components/Immersive/ImmaterialSpaces/ImmaterialSpaces").then(module => ({ default: module.ImmaterialSpaces })));
const BreathtakingVisitorBook = lazy(() => import('./components/Immersive/BreathtakingVisitorBook/BreathtakingVisitorBook').then(module => ({ default: module.BreathtakingVisitorBook })));

// Apps - each component loaded only when needed
const StreetQuest = lazy(() => import("./components/Apps/StreetQuest/StreetQuest").then(module => ({ default: module.StreetQuest })));
const StreetStory = lazy(() => import("./components/Apps/StreetStory/StreetStory").then(module => ({ default: module.StreetStory })));
const XrH = lazy(() => import("./components/Apps/XrH/XrH").then(module => ({ default: module.XrH })));
const AirTime = lazy(() => import("./components/Apps/AirTime/AirTime").then(module => ({ default: module.AirTime })));
const MatterBot = lazy(() => import("./components/Apps/MatterBot/MatterBot").then(module => ({ default: module.MatterBot })));

// Moving Image - each component loaded only when needed
const ThomasHighflyer = lazy(() => import("./components/MovingImage/ThomasHigflyer/ThomasHigflyer").then(module => ({ default: module.ThomasHighflyer })));
const InPlaceOfSilence = lazy(() => import("./components/MovingImage/InPlaceofSilence/InPlaceOfSilence").then(module => ({ default: module.InPlaceOfSilence })));
const OfTheSea = lazy(() => import("./components/MovingImage/OfTheSea/OfTheSea").then(module => ({ default: module.OfTheSea })));

// Photography - each component loaded only when needed
const UnknownPortrait = lazy(() => import("./components/Photography/UnknownPortrait/UnknownPortrait").then(module => ({ default: module.UnknownPortrait })));
const KapanoFC = lazy(() => import("./components/Photography/KapanoFC/KapanoFC").then(module => ({ default: module.KapanoFC })));
const StudentLife = lazy(() => import("./components/Photography/StudenLife/StudentLife").then(module => ({ default: module.StudentLife })));
const Student = lazy(() => import("./components/Photography/Student/Student").then(module => ({ default: module.Student })));
const Pelham = lazy(() => import("./components/Photography/Pelham/Pelham").then(module => ({ default: module.Pelham })));
const Museum = lazy(() => import("./components/Photography/Museum/Museum").then(module => ({ default: module.Museum })));

// Publications - each component loaded only when needed
const CreatingWithTechnology = lazy(() => import("./components/Publications/CreatingWithTechnology/CreatingWithTechnology").then(module => ({ default: module.CreatingWithTechnology })));
const GeoVisualStories = lazy(() => import("./components/Publications/GeoVisualStories/GeoVisualStories").then(module => ({ default: module.GeoVisualStories })));  
const SpaceCowGirl = lazy(() => import("./components/Publications/SpaceCowGirl/SpaceCowGirl").then(module => ({ default: module.SpaceCowGirl })));
const LegaciesOfBritishSlavery = lazy(() => import("./components/Publications/LegaciesOfBritishSlavery/LegaciesOfBritishSlavery").then(module => ({ default: module.LegaciesOfBritishSlavery })));
const FashionCitiesAfrica = lazy(() => import("./components/Publications/FashionCitiesAfrica/FashionCitiesAfrica").then(module => ({ default: module.FashionCitiesAfrica })));
const PhotoworksBiennial = lazy(() => import("./components/Publications/PhotoworksBiennial/PhotoworksBiennial").then(module => ({ default: module.PhotoworksBiennial })));
const Carnival = lazy(() => import("./components/Publications/Carnival/Carnival").then(module => ({ default: module.Carnival })));
const PositiveHairDay = lazy(() => import("./components/Publications/PositiveHairDay/PositiveHairDay").then(module => ({ default: module.PositiveHairDay })));
const Jubilee = lazy(() => import("./components/Publications/Jubilee/Jubilee").then(module => ({ default: module.Jubilee })));

// Research - each component loaded only when needed
const Journal = lazy(() => import("./components/Research/Journal/Journal").then(module => ({ default: module.Journal })));  
const GuidedWalks = lazy(() => import("./components/Research/GuidedWalks/GuidedWalks").then(module => ({ default: module.GuidedWalks }))); 

// Contact
const Contact = lazy(() => import("./components/Contact/Contact").then(module => ({ default: module.Contact })));

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcx0Ifzup1vjYoP7Wtt0gNZnRaZ82azTE",
  authDomain: "lovespicturesinterim.firebaseapp.com",
  projectId: "lovespicturesinterim",
  storageBucket: "lovespicturesinterim.firebasestorage.app",
  messagingSenderId: "1050231176570",
  appId: "1:1050231176570:web:a466a0a7571523ea0daac3",
  measurementId: "G-BWYL1NCK0Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



function App() {
  // Disable right-click with enhanced image protection
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable common keyboard shortcuts
    const handleKeyDown = (e) => {
      // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.ctrlKey && e.shiftKey && e.key === 'J') ||
        (e.ctrlKey && e.key === 'u') ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }

      // Disable Ctrl+S (Save As)
      if (e.ctrlKey && (e.key === 's' || e.key === 'S')) {
        e.preventDefault();
        return false;
      }

      // Disable Ctrl+A (Select All)
      if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
        e.preventDefault();
        return false;
      }

      // Disable Ctrl+C (Copy)
      if (e.ctrlKey && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault();
        return false;
      }

      // Disable Ctrl+P (Print)
      if (e.ctrlKey && (e.key === 'p' || e.key === 'P')) {
        e.preventDefault();
        return false;
      }
    };

    // Disable drag and drop on images
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable text selection
    const handleSelectStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('selectstart', handleSelectStart);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  // -------------------

  return (
    <div className="protected-content">
      <BrowserRouter>
        {/* Single Suspense wrapper replaces all the individual ones */}
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<SharedLayout />}>
              <Route index element={<Home />} />

              {/* Immersive - exact same paths, just cleaner */}
              <Route path="immersive">
                <Route path="haze" element={<Haze />} />
                <Route path="VirtualPavilion" element={<VirtualPavilion />} />
                <Route path="BreathTaking" element={<BreathTaking />} />
                <Route path="Watching" element={<Watching />} />
                <Route path="ImmaterialSpaces" element={<ImmaterialSpaces />} />
                <Route
                  path="BreathtakingVisitorBook"
                  element={<BreathtakingVisitorBook />}
                />
              </Route>

              {/* Apps - exact same paths, just cleaner */}
              <Route path="apps">
                <Route path="MatterBot" element={<MatterBot />} />
                <Route path="StreetQuest" element={<StreetQuest />} />
                <Route path="XrH" element={<XrH />} />
                <Route path="StreetStory" element={<StreetStory />} />
                <Route path="AirTime" element={<AirTime />} />
              </Route>

              {/* Moving Image - exact same paths, just cleaner */}
              <Route path="moving-image">
                <Route path="ThomasHighflyer" element={<ThomasHighflyer />} />
                <Route path="InPlaceOfSilence" element={<InPlaceOfSilence />} />
                <Route path="OfTheSea" element={<OfTheSea />} />
              </Route>

              {/* Photography - exact same paths, just cleaner */}
              <Route path="photography">
                <Route path="UnknownPortrait" element={<UnknownPortrait />} />
                <Route path="StudentLife" element={<StudentLife />} />
                <Route path="student" element={<Student />} />
                <Route path="pelham" element={<Pelham />} />
                <Route path="museum" element={<Museum />} />
              </Route>

              {/* Publications - exact same paths, just cleaner */}
              <Route path="publications">
                <Route path="carnival" element={<Carnival />} />
                <Route path="KapanoFC" element={<KapanoFC />} />
                <Route path="PositiveHairDay" element={<PositiveHairDay />} />
                <Route path="Jubilee" element={<Jubilee />} />
                <Route
                  path="PhotoworksBiennial"
                  element={<PhotoworksBiennial />}
                />
                <Route
                  path="FashionCitiesAfrica"
                  element={<FashionCitiesAfrica />}
                />
                <Route path="SpaceCowGirl" element={<SpaceCowGirl />} />
                <Route path="GeoVisualStories" element={<GeoVisualStories />} />
                <Route
                  path="CreatingWithTechnology"
                  element={<CreatingWithTechnology />}
                />
                <Route
                  path="LegaciesOfBritishSlavery"
                  element={<LegaciesOfBritishSlavery />}
                />
              </Route>

              {/* Research - exact same paths, just cleaner */}
              <Route path="research">
                <Route path="journal" element={<Journal />} />
                <Route path="GuidedWalks" element={<GuidedWalks />} />
              </Route>

              {/* Contact - exact same path, just cleaner */}
              <Route path="contact">
                <Route path="contact" element={<Contact />} />
              </Route>

              <Route path="*" element={<Error />} />
            </Route>
          </Routes>
        </Suspense>
        <Navbar />
      </BrowserRouter>
    </div>
  );
}

export default App;
